import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Helper } from '../helper.service';
import { UserModel } from '../../models/user/user.model';
import { catchError, Observable } from 'rxjs';
import { PermissionModel } from '../../models/user/permission.model';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class PermissionService {
  options: any;
  permissions: Observable<any> = new Observable<any>();
  user: UserModel | null = null; // Initialize user with a new instance
  constructor(
    private http: HttpClient,
    private helperService: Helper,
  ) {}

  getPermissions(): Observable<any> {
    this.options = { headers: this.helperService.getApiAuthHeader() };
    return this.http.get(environment.permissionServiceEndPoint, this.options).pipe(catchError(this.helperService.handleError));
  }

  updatePermission(newPermission: PermissionModel): Observable<any> {
    this.options = { headers: this.helperService.getApiAuthHeader() };
    // Backend only exposes PATCH on the bare route (id comes from the body) - PUT + id in
    // the URL never matched any backend action and 404'd.
    return this.http.patch(environment.permissionServiceEndPoint, JSON.stringify(newPermission), this.options).pipe(catchError(this.helperService.handleError));
  }

  // Permissions are created and deleted only via DB migration - the backend no longer exposes
  // create/delete endpoints, for any role including sysadmin.

  setPermissions(permission: PermissionModel) {
    sessionStorage.setItem('permissions', JSON.stringify(permission));
  }
}
